import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref } from "vue";
  import { required, email, helpers, minLength } from "@vuelidate/validators";
  import useVuelidate from "@vuelidate/core";
  import store from "@/store";
  import Cleave from "vue-cleave-component";
  import { phoneNumberOption } from "@/helpers/cleavePlugin";
  import { validPhoneNumber } from "@/helpers/validation";
  import { useToast } from "vue-toastification";

  const VALID_PHONE_NUMBER_ERROR_TEXT = "Value must be valid phone number";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ContactUsForm',
  setup(__props, { expose: __expose }) {
  __expose();

  const toast = useToast();
  const isSubmitting = ref(false);
  const form = reactive({
    fullName: "",
    company: "",
    email: "",
    message: "",
    phone: "",
  });
  const rules = {
    fullName: { required, $autoDirty: true },
    company: { required, $autoDirty: true },
    email: { required, email, $autoDirty: true },
    phone: {
      validPhoneNumber: helpers.withMessage(
        VALID_PHONE_NUMBER_ERROR_TEXT,
        validPhoneNumber
      ),
    },
    message: { minLength: minLength(10), $autoDirty: true },
  };
  const v$ = useVuelidate(rules, form, { $scope: false });
  const resetForm = () => {
    Object.keys(form).forEach((index) => {
      form[index] = "";
    });
    v$.value.$reset();
  };
  const submit = async () => {
    v$.value.$touch();
    const isFormCorrect = await v$.value.$validate();

    if (!isFormCorrect || isSubmitting.value) return;

    isSubmitting.value = true;
    store
      .dispatch("user/contactEmail", form)
      .then(() => {
        resetForm();
        toast.success("Message sent successfully");
      })
      .finally(() => {
        isSubmitting.value = false;
      });
  };

const __returned__ = { toast, isSubmitting, VALID_PHONE_NUMBER_ERROR_TEXT, form, rules, v$, resetForm, submit, reactive, ref, get required() { return required }, get email() { return email }, get helpers() { return helpers }, get minLength() { return minLength }, get useVuelidate() { return useVuelidate }, get store() { return store }, get Cleave() { return Cleave }, get phoneNumberOption() { return phoneNumberOption }, get validPhoneNumber() { return validPhoneNumber }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})